import "./assets/scss/hope-ui.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/dark.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/customizer.scss";
import "./assets/custom/css/custom.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./components/partials/components/loader";
// import AppNotification from "./AppNotification";

import { useState, useEffect } from "react";


import { useDispatch, useSelector } from 'react-redux';
import { setSetting } from './store/setting/actions'
import * as SettingSelector from './store/setting/selectors'

import { FloatingPanelProvider } from "./views/dashboard/desposition/useFloatingPanelState";
import { SidebarPositionProvider } from "./router/context/SidebarPositionContext";
import { getApiCall } from "./service/httpCall";
import { API_GET_USER } from "./service/url";
import { ROUTES, USER_ROLES } from "./utilities/constant";
import { Storage } from "./utilities/setting";

function App({ children }) {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const dispatch = useDispatch();
  const themeScheme = useSelector(SettingSelector.theme_scheme);

  useEffect(() => {
    dispatch(setSetting());
  }, [dispatch]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const rawUser = Storage.getItem("user");
        const user = JSON.parse(rawUser);

        if (user?.role !== USER_ROLES.CALL_CENTRE_AGENT) {
          return
        }

        if (!user) {
          setIsCheckingAuth(false);
          return;
        }

        const resp = await getApiCall(
          `${API_GET_USER}/${user?.id}?t=${Date.now()}`
        );

        if (!resp?.login_at) {
          localStorage.clear();
          Storage.clearAll();

          window.location.href = ROUTES.LOGIN;
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const savedBodyFont =
      localStorage.getItem("bodyFont") ||
      "'Poppins', sans-serif";

    const savedHeadingFont =
      localStorage.getItem("headingFont") ||
      "'Montserrat', sans-serif";

    document.documentElement.style.setProperty(
      "--body-font",
      savedBodyFont
    );

    document.documentElement.style.setProperty(
      "--heading-font",
      savedHeadingFont
    );
  }, []);

  if (isCheckingAuth) {
    return  <Loader />;
  }

  return (
    <SidebarPositionProvider>
    <FloatingPanelProvider>
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={themeScheme === "dark" ? "dark" : "light"}
    />
      {children}
      {/* <AppNotification /> */}
    </FloatingPanelProvider>
    </SidebarPositionProvider>
  );
}

export default App;